import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, MapPin, Clock } from 'lucide-react';
import { Hero } from '../components/Hero';
import { FeaturedItems } from '../components/FeaturedItems';
const STOREFRONT_IMG = 'https://cdn.magicpatterns.com/uploads/eXCtDymCaaxJyyjcCGY8UZ/IMG_1811.jpg';
const TEAM_IMG = 'https://cdn.magicpatterns.com/uploads/nwaFokr74juteZS55uN5r6/IMG_1797.jpg';
const FEEP_IMG = 'https://cdn.magicpatterns.com/uploads/6Jqi6t9HeDymL6x7JQUrSp/IMG_1798.jpg';
const FAMOUS_IMG = 'https://cdn.magicpatterns.com/uploads/oYw5WxSBomKoDdN4KmjEnn/Captura_de_pantalla_2026-05-27_a_las_12.37.00.png';
const PADEL_IMG = 'https://cdn.magicpatterns.com/uploads/2xDSsFiXr71TdAbWGwc8Ub/Captura_de_pantalla_2026-05-27_a_las_12.38.48.png';
export function Home() {
  return <div className="flex flex-col w-full" data-id="element-340">
      <Hero data-id="element-341" />
      <FeaturedItems data-id="element-342" />
      {/* Visítanos — terraza */}
      <section className="py-24 bg-cafe-bg" data-id="element-343">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-344">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative rounded-3xl overflow-hidden shadow-soft aspect-[4/5] order-2 md:order-1" data-id="element-345">
            <img src={STOREFRONT_IMG} alt="Terraza de Trastienda Café con clientes disfrutando del ambiente" className="w-full h-full object-cover" data-id="element-346" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="order-1 md:order-2" data-id="element-347">
            <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-348">
              Visítanos
            </span>
            <h2 className="text-3xl md:text-5xl font-serif text-cafe-primary mt-3 mb-6 leading-tight" data-id="element-349">
              Tu rincón <span className="italic" data-id="element-350">favorito</span> del barrio
            </h2>
            <p className="text-cafe-text/80 text-lg leading-relaxed mb-6" data-id="element-351">
              Disfruta de nuestra terraza tranquila y nuestro interior acogedor.
              Un espacio pensado para que te sientas como en casa desde el
              primer momento.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-352">
              <li className="flex items-center gap-3 text-cafe-text/80" data-id="element-353">
                <MapPin size={18} className="text-cafe-accent flex-shrink-0" data-id="element-354" />
                <span data-id="element-355">Te esperamos en pleno corazón del barrio</span>
              </li>
              <li className="flex items-center gap-3 text-cafe-text/80" data-id="element-356">
                <Clock size={18} className="text-cafe-accent flex-shrink-0" data-id="element-357" />
                <span data-id="element-358">Abiertos cada día para acompañarte</span>
              </li>
            </ul>
            <Link to="/contacto" className="inline-block border-b-2 border-cafe-accent text-cafe-primary font-medium pb-1 hover:text-cafe-accent transition-colors" data-id="element-359">
              Cómo llegar
            </Link>
          </motion.div>
        </div>
      </section>
      {/* Teaser Sobre Nosotros */}
      <section className="py-24 bg-cafe-card" data-id="element-360">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-361">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-362">
            <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-363">
              Nuestra historia
            </span>
            <h2 className="text-3xl md:text-5xl font-serif text-cafe-primary mt-3 mb-6 leading-tight" data-id="element-364">
              Un café de barrio,
              <br data-id="element-365" />
              <span className="italic" data-id="element-366">hecho con cariño</span>
            </h2>
            <p className="text-lg text-cafe-text/80 leading-relaxed mb-6" data-id="element-367">
              Desde 2021, en Trastienda Café creamos un ambiente acogedor donde
              cada visita se siente como estar en casa. Nuestra pasión son los
              crepes, las tostas y los batidos artesanos, preparados con
              dedicación para acompañar tus mejores momentos.
            </p>
            <Link to="/sobre" className="inline-block border-b-2 border-cafe-accent text-cafe-primary font-medium pb-1 hover:text-cafe-accent transition-colors" data-id="element-368">
              Conoce más sobre nosotros
            </Link>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="rounded-3xl overflow-hidden shadow-soft aspect-[4/5]" data-id="element-369">
            <img src={TEAM_IMG} alt="Equipo de Trastienda Café bajo el cartel del local" className="w-full h-full object-cover" data-id="element-370" />
          </motion.div>
        </div>
      </section>
      {/* Famosos que nos visitan */}
      <section className="py-20 md:py-28 bg-white" data-id="element-371">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-372">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center max-w-2xl mx-auto mb-14" data-id="element-373">
            <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-374">
              Famosos que nos visitan
            </span>
            <h2 className="text-3xl md:text-5xl font-serif text-cafe-primary mt-3 mb-4" data-id="element-375">
              Tu rincón, también el de ellas
            </h2>
            <div className="w-24 h-px bg-cafe-accent mx-auto" data-id="element-376" />
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-14 items-center max-w-5xl mx-auto" data-id="element-377">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="aspect-[4/5] rounded-3xl overflow-hidden shadow-soft order-2 md:order-1" data-id="element-378">
              <img src={FAMOUS_IMG} alt="Las jugadoras profesionales de pádel Lucía Sainz y Aranza Osoro bajo el cartel de Trastienda Café" className="w-full h-full object-cover" data-id="element-379" />
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="order-1 md:order-2" data-id="element-380">
              <p className="text-cafe-text/80 text-lg leading-relaxed mb-5" data-id="element-381">
                Las jugadoras profesionales de pádel{' '}
                <span className="font-medium text-cafe-primary" data-id="element-382">
                  Lucía Sainz
                </span>{' '}
                y{' '}
                <span className="font-medium text-cafe-primary" data-id="element-383">
                  Aranza Osoro
                </span>{' '}
                desayunaron con nosotras una mañana. Momentos así nos recuerdan
                por qué empezamos.
              </p>
              <p className="text-cafe-text/70 italic leading-relaxed" data-id="element-384">
                Si nos visitas, eres parte de nuestra historia.
              </p>
            </motion.div>
          </div>

          {/* Padel team callout */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="mt-16 max-w-5xl mx-auto bg-cafe-card/50 rounded-3xl overflow-hidden" data-id="element-385">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center" data-id="element-386">
              <div className="p-8 md:p-12 lg:p-14 text-center md:text-left" data-id="element-387">
                <span className="text-cafe-accent text-xs tracking-[0.3em] uppercase font-medium block mb-3" data-id="element-388">
                  Más allá del café
                </span>
                <h3 className="text-2xl md:text-3xl font-serif text-cafe-primary mb-4 leading-tight" data-id="element-389">
                  El equipo La Trastienda
                </h3>
                <p className="text-cafe-text/70 leading-relaxed" data-id="element-390">
                  Nuestra trastienda va más allá del local — también competimos
                  en la pista con nuestro propio equipo de pádel.
                </p>
              </div>
              <div className="aspect-[4/3] md:aspect-square overflow-hidden" data-id="element-391">
                <img src={PADEL_IMG} alt="Equipo de pádel La Trastienda con sus uniformes oficiales en la pista" className="w-full h-full object-cover" data-id="element-392" />
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Causa Solidaria CTA */}
      <section className="py-24 bg-cafe-primary text-white overflow-hidden" data-id="element-393">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-394">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-395">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="order-2 md:order-1 relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square border border-white/10" data-id="element-396">
              <img src={FEEP_IMG} alt="Bandera de Trastienda Café en el campo base del Everest junto a la Fundación Española de Enfermedades Priónicas" className="w-full h-full object-cover" data-id="element-397" />
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="order-1 md:order-2 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-398">
              <Heart size={48} className="text-cafe-accent mb-6" strokeWidth={1.5} data-id="element-399" />
              <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-400">
                Un café con propósito
              </h2>
              <p className="text-lg text-white/80 leading-relaxed mb-10 max-w-xl" data-id="element-401">
                Trastienda Café apoya activamente a la Fundación Española de
                Enfermedades Priónicas (FEEP). Descubre cómo puedes colaborar
                con esta importante causa.
              </p>
              <Link to="/donaciones" className="inline-flex justify-center items-center px-8 py-4 text-base font-medium rounded-full text-cafe-primary bg-white hover:bg-cafe-card transition-colors duration-200" data-id="element-402">
                Hacer una donación
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}